<template lang="pug">
  div
    div(class="py-2")
      div(class="border")
        div(class="border-bottom text-center py-2") 付款方式
        div(class="d-flex flex-column flex-lg-row" :class="{'border-top': index}" v-for="(item, index) in paymentMethodList" :key="item.id")
          div(class="col-auto py-3" style="width: 200px;")
            div(class="row mx-n1 radio-group h-100 justify-content-lg-center align-items-center")
              div(class="col-auto custom-control custom-radio my-2")
                input(type="radio" class="custom-control-input" :id="'pay-' + convPaymentById(item.id)" :class="{'is-invalid': hasError(model, 'payment')}" v-model="currentPayment" :value="item.id" @change="changePayment")
                label(class="custom-control-label" :for="'pay-' + convPaymentById(item.id)" style="width:120px;") {{ item.name }}
          div(class="col py-3")
            div(class="articel-content" v-html="item.content")
            template(v-if="item.id === 1 && currentPayment === 1")
              div(class="row")
              template(v-for="data in installmentData")
                div(class="col-auto custom-control custom-radio my-2" v-if="data.condition()")
                  input(type="radio" class="custom-control-input" :id="'installment-' + data.value" :class="{'is-invalid': hasError(model, 'installment')}" @change="changeInstallment" v-model="model.installment" :value="data.value")
                  label(class="custom-control-label" :for="'installment-' + data.value" style="width:120px;") {{ data.name }}
              ErrorMessage(class="mt-0" :model="model" handle="installment")
            template(v-if="item.id === 4 && currentPayment === 4")
              div(class="row")
                div(class="col-auto from-title") 匯款帳號末五碼
                div(class="col" style="max-width: 225px;")
                  InputBox(class="my-2" type="text" placeholder="請輸入帳號末五碼" :model="model" handle="card_number" :watch="true" :rules="cardNumberRule")
                  ErrorMessage(class="mt-0" :model="model" handle="card_number")
              div(class="row")
                div(class="col-auto from-title") 匯款日期
                div(class="col")
                  div(class="d-flex flex-wrap mx-n1")
                    div(class="col-auto custom-center custom-radio my-2" v-for="(data, index) in remittanceDays")
                      input(type="radio" class="custom-control-input" :id="'installment-' + index" :class="{'is-invalid': hasError(model, 'atm_day')}" v-model="model.atm_day" :value="data")
                      label(class="custom-control-label" :for="'installment-' + index" style="width:120px;") {{ dayFormat(data, 'YYYY/MM/DD') }}
                  ErrorMessage(class="mt-0" :model="model" handle="atm_day")
    div(class="pb-5")
      ErrorMessage(class="text-center text-lg-right" :model="model" handle="error_message")
      div(class="row mx-n1 py-2 justify-content-end align-items-center flex-column flex-lg-row")
        //router-link(class="" to="/member/shopcart/step/2") 上一步
        button(class="w-100 btn btn-outline-success m-1 max-w-300 max-w-lg-180" @click="preStep" type="button") 上一步
        button(class="w-100 btn btn-success m-1 max-w-300" @click="nextStep" type="button" :disabled="checkingCart")
          span(class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" v-if="checkingCart")
          span {{ checkingCart ? '處理中...' : '下一步' }}
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { createShopcart, getRemittanceDays, getShopcartAvailability, validateOrders } from '../../../api'
import { v4 as uuidv4 } from 'uuid'
import { Toast } from '@/utils/helper'
import {
  isShoppingMaintenanceError,
  showShoppingMaintenanceAndReturnHome
} from '@/library/shopping-maintenance'

function isMaintenanceError (error) {
  return Boolean(
    error &&
    error.response &&
    error.response.data &&
    error.response.data.message === '網站關閉維護中'
  )
}

function escapeHtml (value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

function changedProductList (items) {
  const rows = (Array.isArray(items) ? items : [])
    .map(item => `<div style="display:flex;gap:10px;line-height:1.55;font-weight:600;"><span aria-hidden="true">•</span><span>${escapeHtml(item)}</span></div>`)
    .join('')

  return `<div style="width:fit-content;max-width:100%;margin:16px auto 0;color:#555;text-align:left;">${rows}</div>`
}

export default {
  data () {
    return {
      model: this.$parent.model,
      installmentData: [
        { name: '不分期', value: 0, condition: () => true },
        { name: '分3期', value: 3, condition: () => this.model.total_price_new >= 3000 },
        { name: '分6期', value: 6, condition: () => this.model.total_price_new >= 10000 },
        { name: '分9期', value: 9, condition: () => this.model.total_price_new >= 25000 }
      ],
      currentPayment: 0,
      remittanceDays: [],
      uuid: {
        office: uuidv4()
      },
      cardNumberRule: () => {
        if (this.model.payment === 'ATM') {
          if (this.model.card_number.length > 5) {
            this.model.card_number = this.model.card_number.substring(0, 4)
            // console.log('this.card_number', this.model.card_number)
            return false
          }
          return {
            presence: {
              allowEmpty: false,
              message: '^請填寫匯款帳號後5碼'
            },
            length: {
              minimum: 5,
              tooShort: '^請填寫匯款帳號末5碼',
              maximum: 5,
              tooLong: '^請填寫匯款帳號末5碼'
            },
            format: {
              pattern: '^\\d\\d\\d\\d\\d$',
              flags: 'i',
              message: '^請填寫匯款帳號末5碼'
            }
          }
        }
        return {}
      },
      paymentMethodList: [],
      checkingCart: false
    }
  },
  updated () {
    // console.log('remittanceDays', this.remittanceDays)
  },
  created () {
    const step = Number(this.$parent.step)
    if (step === 3) {
      this.$parent.step = 3
    } else {
      this.$router.replace('1')
    }
    this.getListModel({ name: 'PaymentMethods' }).then(res => {
      this.paymentMethodList = Array.isArray(res.data) ? res.data : []
      this.clearUnavailablePayment()
    })
    getRemittanceDays().then(res => {
      this.remittanceDays = res.data
    })
    if (localStorage.getItem('payment') !== null) {
      // console.log('storage has payment', localStorage.getItem('payment'))
      this.model.payment = localStorage.getItem('payment')
      if (localStorage.getItem('payment') === 'taiShinCard') {
        this.currentPayment = 1
        if (localStorage.getItem('installment') !== null) {
          // console.log('storage  total_price_new', localStorage.getItem('total_price_new'))
          // console.log('storage  this.model.total_price_new', this.model.total_price_new)

          if (localStorage.getItem('total_price_new') !== null && parseInt(localStorage.getItem('total_price_new')) > this.model.total_price_new) {
            // console.log('storage has total_price_new', localStorage.getItem('total_price_new'))
            if (this.model.total_price_new >= 3000) {
              localStorage.setItem('installment', '0')
            } else if (this.model.total_price_new >= 10000) {
              localStorage.setItem('installment', '0')
            } else if (this.model.total_price_new >= 25000) {
              localStorage.setItem('installment', '0')
            }
          }
          this.model.installment = localStorage.getItem('installment')
          if (Number(this.model.installment) === 12) {
            this.model.installment = 0
            localStorage.setItem('installment', '0')
          }
        }
      } else if (localStorage.getItem('payment') === 'card') {
        this.currentPayment = 2
      } else if (localStorage.getItem('payment') === 'unionPay') {
        this.currentPayment = 3
      } else if (localStorage.getItem('payment') === 'ATM') {
        this.currentPayment = 4
      }
    } else {
      if (this.model.order_items.length && this.model.order_items.every(p => p.is_lucky)) {
        // console.log('found lucky')
        this.model.set({
          payment: 'taiShinCard',
          installment: '0'
        })
        this.currentPayment = 1
        this.changePayment()
      } else {
        // console.log('not found lucky')
      }
    }
    // console.log('step 3 this.OrderModel', this.currentPayment)
    localStorage.setItem('total_price_new', this.model.total_price_new)
  },
  computed: {
    ...mapState({
      PaymentMethods: state => state.model.PaymentMethods,
      ShopCarts: state => state.model.ShopCarts,
      UserData: state => state.model.UserData
    })
  },
  methods: {
    ...mapActions(['getListModel']),
    clearUnavailablePayment () {
      const selectedPaymentId = Number(this.currentPayment)
      const isAvailable = this.paymentMethodList.some(item => Number(item.id) === selectedPaymentId)
      if (!selectedPaymentId || isAvailable) {
        return
      }

      this.currentPayment = 0
      this.model.payment = ''
      this.model.atm_day = ''
      this.model.card_number = ''
      localStorage.removeItem('payment')
    },
    convPaymentById (id) {
      // console.log('convPaymentById', id)
      switch (Number(id)) {
        case 1: return 'taiShinCard'
        case 2: return 'card'
        case 3: return 'unionPay'
        case 4: return 'ATM'
        default: return ''
      }
    },
    changeInstallment () {
      localStorage.setItem('installment', this.model.installment)
    },
    changePayment () {
      // console.log('changePayment', this.currentPayment)
      this.model.payment = this.convPaymentById(this.currentPayment)
      // console.log('this.model.payment', this.model.payment)

      if (this.model.payment === 'taiShinCard') {
        this.model.installment = 0
        localStorage.setItem('installment', this.model.installment)
      } else {
        this.model.installment = 0
        localStorage.setItem('installment', this.model.installment)
      }
      // console.log('this.model.installment', this.model.installment)
      localStorage.setItem('payment', this.model.payment)

      if (this.model.payment !== 'ATM') {
        this.model.atm_day = ''
      }
    },
    preStep () {
      this.$parent.step = 2
      this.$router.push('2')
    },
    getCartRowId (item = {}) {
      return Number(item.id || item.shopcart_id || 0)
    },
    getCartProductId (item = {}) {
      return Number(item.product_id || (item.products && item.products.id) || 0)
    },
    formatClosedProductName (item = {}) {
      const product = item.products || {}
      const productNumber = item.product_number || product.product_number || ''
      const productName = item.name || product.name || ''
      return `${productNumber} ${productName}`.trim()
    },
    syncShopCarts (rows) {
      this.$store.commit('setListModel', {
        name: 'ShopCarts',
        type: this.ShopCarts.modelType,
        list: { data: rows }
      })
      this.ShopCarts.loaded = true
    },
    removeShopCartsFromStore (cartIds) {
      cartIds.forEach(id => {
        const index = this.ShopCarts.data.map(item => Number(item.id)).indexOf(Number(id))
        if (index >= 0) {
          this.ShopCarts.data.splice(index, 1)
        }
      })
    },
    async checkClosedProductsBeforePreview () {
      const currentItems = Array.isArray(this.model.order_items)
        ? this.model.order_items
        : []
      if (!currentItems.length) {
        return false
      }

      const response = await getShopcartAvailability()
      const purchasableRows = Array.isArray(response.data.items) ? response.data.items : []
      const removedRows = Array.isArray(response.data.removed_items) ? response.data.removed_items : []
      this.syncShopCarts(purchasableRows)
      const latestCartIds = purchasableRows.map(item => this.getCartRowId(item)).filter(Boolean)
      const latestProductIds = purchasableRows.map(item => this.getCartProductId(item)).filter(Boolean)

      const closedItems = currentItems.filter(item => {
        const cartId = this.getCartRowId(item)
        if (cartId) {
          return !latestCartIds.includes(cartId)
        }
        const productId = this.getCartProductId(item)
        return productId && !latestProductIds.includes(productId)
      })

      const closedNames = [
        ...removedRows.map(item => this.formatClosedProductName(item)),
        ...closedItems
          .filter(item => !removedRows.some(row => this.getCartProductId(row) === this.getCartProductId(item)))
          .map(item => this.formatClosedProductName(item))
      ].filter(Boolean)

      const adjustedNames = []
      const soldOutNames = []
      await Promise.all(purchasableRows.map(async row => {
        const current = currentItems.find(item =>
          this.getCartProductId(item) === this.getCartProductId(row)
        )
        if (!current) {
          return
        }
        const requested = Number(row.product_quantity || 0)
        const stock = Number(
          row.products && row.products.stock
            ? row.products.stock.quantity
            : requested
        )
        const adjusted = Math.max(0, Math.min(requested, stock))
        const oldQuantity = Number(current.quantity || current.product_quantity || 0)
        const label = this.formatClosedProductName(row)
        if (adjusted <= 0) {
          soldOutNames.push(label)
          return
        }
        if (adjusted !== requested) {
          await createShopcart({ ...row, product_quantity: adjusted })
        }
        if (adjusted !== oldQuantity) {
          adjustedNames.push(label)
        }
      }))

      if (!closedNames.length && !adjustedNames.length && !soldOutNames.length) {
        return false
      }

      this.model.total_price = 0
      this.model.total_pv = 0
      this.model.total_price_new = 0
      await Toast.fire({
        icon: 'warning',
        title: '商品有異動，請重新檢查：',
        html: changedProductList([...adjustedNames, ...soldOutNames, ...closedNames]),
        confirmButtonColor: '#00802F',
        customClass: {
          confirmButton: 'cart-alert-confirm-button'
        }
      })
      this.$parent.step = 1
      this.$router.push('1')
      return true
    },
    async nextStep () {
      if (this.checkingCart) {
        return
      }
      const errorMessage = this.model.validate({
        error_message: () => {
          if (!['taiShinCard', 'unionPay', 'card', 'ATM'].includes(this.model.payment)) {
            return { inclusion: { message: '^請選擇付款方式' } }
          }
          return {}
        },
        installment: () => {
          if (this.model.payment === 'taiShinCard') {
            return {
              presence: {
                allowEmpty: false,
                message: '^請選擇分期期數'
              }
            }
          }
          return {}
        },
        atm_day: () => {
          if (this.model.payment === 'ATM') {
            return {
              presence: {
                allowEmpty: false,
                message: '^請選擇付款日期'
              }
            }
          }
          return {}
        },
        card_number: this.cardNumberRule
      })
      if (errorMessage) {
        return
      }
      console.log(this.model.payment)
      console.log(this.model.atm_day)

      this.checkingCart = true
      try {
        const hasClosedProducts = await this.checkClosedProductsBeforePreview()
        if (hasClosedProducts) {
          return
        }
        await validateOrders(this.model.toDatabase())
      } catch (error) {
        console.error('[shopcart/Step3] check closed products failed:', error)
        if (isMaintenanceError(error)) {
          return
        }
        if (isShoppingMaintenanceError(error)) {
          await showShoppingMaintenanceAndReturnHome(this.$router)
          return
        }
        const status = Number(error && error.response && error.response.data && error.response.data.status_from_backend)
        if (status === 4092) {
          this.currentPayment = 0
          this.model.payment = ''
          this.model.atm_day = ''
          this.model.card_number = ''
          localStorage.removeItem('payment')
          await Toast.fire({
            icon: 'warning',
            title: '付款方式暫停使用',
            text: '此付款方式目前正在維護，請重新選擇付款方式。',
            confirmButtonText: '確認',
            confirmButtonColor: '#00802F'
          })
          return
        }
        if ([4010, 4011, 4012, 4013].includes(status)) {
          const message = error && error.response && error.response.data && error.response.data.message
          await Toast.fire({
            icon: 'warning',
            title: '贈品數量異動，請重新選擇',
            html: changedProductList([
              message || '活動贈品將依目前商品、數量及剩餘配額重新計算'
            ]),
            confirmButtonText: '回購物車確認',
            confirmButtonColor: '#00802F'
          })
          this.$parent.step = 1
          this.$router.push('1')
          return
        }
        await Toast.fire({
          icon: 'error',
          title: '購物車更新失敗',
          text: '請重新檢查或稍後再試',
          confirmButtonText: '確認',
          allowOutsideClick: false,
          allowEscapeKey: false
        })
        return
      } finally {
        this.checkingCart = false
      }

      this.$parent.step = 4
      this.$router.push('4')
    }
  }
}
</script>

<style lang="scss" scoped>
  .from-title {
    width: 150px;
    margin-top: 16px;
  }
</style>
